jQuery(document).ready(function(){
    "use strict";

    console.log("ICI Scripts Mr Goodfish !");

    var hauteurChoixfiltre, maxHeight, positionChoix;
    if (jQuery('.choix-filtre').length > 0) {
        hauteurChoixfiltre = jQuery(document).height();
        if (jQuery('.liste-posts').length > 0) {
            positionChoix = jQuery('.liste-posts').offset();
        }
        maxHeight = hauteurChoixfiltre - positionChoix.top - 80; // 80 = hauteur des boutons et du padding de #liste-adherents
        jQuery('.liste-choix').css('max-height',maxHeight+'px');

        onHashchange();
    }

    jQuery('.resultat-filtre').click(function () {
        var open = jQuery(this).next('.choix-filtre').css('display');

        jQuery('.choix-filtre').css('display', 'none');
        jQuery('.resultat-filtre i').removeClass('rotate');
        jQuery('.liste-resultats').removeClass('opacite-filtre');
        jQuery('.filtres-posts').removeClass('opacite-filtre');
        if (open === 'none') {
            jQuery(this).next('.choix-filtre').css('display', 'table');
            jQuery(this).find('i').addClass('rotate');
            jQuery('.liste-resultats').addClass('opacite-filtre');
            jQuery('.filtres-posts').addClass('opacite-filtre');
        }
    });
    jQuery('.filtre-annuler').click(function () {
        jQuery('.choix-filtre').css('display', 'none');
        jQuery('.resultat-filtre i').removeClass('rotate');
        jQuery('.liste-resultats').removeClass('opacite-filtre');
        jQuery('.filtres-posts').removeClass('opacite-filtre');
    });

    jQuery('.liste-adherents').on('.card-adherent div',{
        mouseenter: function () {
            console.log("Hover", jQuery(this).attr('data-marker_id'));
        },
        mouseleave: function () {

        }
    });

    jQuery('.liste-adherents').on('mouseenter','.card-adherent div', function(){
        var id = jQuery(this).attr('data-marker_id');
        jQuery('.adherent-marker[data-marker_id=\''+id+'\']').addClass('marker-hover');
    });
    jQuery('.liste-adherents').on('mouseleave','.card-adherent div', function(){
        var id = jQuery(this).attr('data-marker_id');
        jQuery('.adherent-marker[data-marker_id=\''+id+'\']').removeClass('marker-hover');
    });

    function getHashFilter() {
        // get filter=filterName
        var matches = location.hash.match( /filter=([^&]+)/i );
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent( hashFilter );
    }


// bind filter button click
//     var inputs  = jQuery('.choix-filtre :checkbox').map(function(){
//         var key   = jQuery(this).attr('id')
//             ,  value = jQuery(this).prop('checked')
//             ,  ret   = {};
//
//         ret[key] = value;
//         return ret;
//     });

    jQuery('.filtre-appliquer').click(function(){
        var filters = jQuery('.choix-filtre :checkbox:checked').map(function(){
            return jQuery(this).attr('data-filter');
        }).get();
        var recherche = jQuery('#recherche-filtre').val();
        if (recherche.length > 0) {
            filters.push('q-'+recherche);
        }
        filters = filters.join(",");
        location.hash = 'filter=' + encodeURIComponent( filters );
        jQuery('.choix-filtre').css('display', 'none');
        jQuery('.resultat-filtre i').removeClass('rotate');
        jQuery('.liste-resultats').removeClass('opacite-filtre');
        jQuery('.filtres-posts').removeClass('opacite-filtre');
    });

    function onHashchange() {
        var hashFilter = getHashFilter();
        if ( !hashFilter ) {
            hashFilter = ' ';
        }
        // // set selected class on button
        if ( hashFilter ) {
            var hashArray = hashFilter.split(',');

            jQuery('.choix-filtre :checkbox').prop('checked',false);

            for(var i=0; i<hashArray.length; i++) {
                if (hashArray[i].substr(0,2) === 'q-') {
                    jQuery('#recherche-filtre').val(hashArray[i].substr(2));
                } else {
                    jQuery('.choix-filtre').find('[data-filter="' + hashArray[i] + '"]').prop('checked',true);
                }
            }
            if (jQuery('#liste-adherents').length > 0) {
                jQuery('#liste-adherents').html('<div class="loading-spinner"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>');
                jQuery.post(
                    ajaxurl,
                    {
                        'action': 'filtre_adherents',
                        'filter': hashFilter
                    },
                    function(response){
                        jQuery('#liste-adherents').html(response.html);
                        window.coordonnees_map = response.coordonnees;
                        var mapadherents = document.getElementById('map-adherents');

                        if (mapadherents) {
                            var map = new google.maps.Map(mapadherents, {
                                zoom: 10,
                                scrollwheel: false,
                            });
                            setMarkers(map);
                        }
                        if (response.categorie !== '') {
                            jQuery('#filtre-type .resultat-filtre span').html(response.categorie);
                        }
                        if (response.region !== '') {
                            jQuery('#filtre-region .resultat-filtre span').html(response.region);
                        }
                        if (response.departement !== '') {
                            jQuery('#filtre-departement .resultat-filtre span').html(response.departement);
                        }
                        if (response.pays !== '') {
                            jQuery('#filtre-pays .resultat-filtre span').html(response.pays);
                        }
                    }
                );
            }
            if (jQuery('#liste-especes').length > 0) {
                var saisonid = jQuery('.saison-bloc').attr('data-saison');
                jQuery('#liste-especes').html('<div class="loading-spinner"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>');
                jQuery.post(
                    ajaxurl,
                    {
                        'action': 'filtre_especes',
                        'filter': hashFilter,
                        'saison': saisonid
                    },
                    function(response){
                        jQuery('#liste-especes').html(response.html);
                        if (response.zone !== '') {
                            jQuery('#filtre-facade .resultat-filtre span').html(response.facade);
                        }
                        if (response.origine !== '') {
                            jQuery('#filtre-origine .resultat-filtre span').html(response.origine);
                        }
                        if (response.recherche !== '') {
                            jQuery('#filtre-nom .resultat-filtre span').html(response.recherche);
                        }
                    }
                );
            }
            if (jQuery('#liste-recettes').length > 0) {
                jQuery('#liste-recettes').html('<div class="loading-spinner"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>');
                jQuery.post(
                    ajaxurl,
                    {
                        'action': 'filtre_recettes',
                        'filter': hashFilter
                    },
                    function(response){
                        jQuery('#liste-recettes').html(response.html);
                        if (response.espece !== '') {
                            jQuery('#filtre-espece .resultat-filtre span').html(response.espece);
                        }
                        if (response.saison !== '') {
                            jQuery('#filtre-saison .resultat-filtre span').html(response.saison);
                        }
                    }
                );
            }
        }
    }

    jQuery(window).on( 'hashchange', onHashchange );

});

